import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _createForOfIteratorHelper from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, packageData } from "@/mixins/index";
import addPackageTask from "./components/addPackageTask";
import packageItem from "./components/packageItem";
import parameterAllDataPopup from "./components/parameterAllDataPopup";
import api from '@/api';
export default {
  name: "packagingTaskManagement",
  mixins: [loadMoreList, packageData],
  components: {
    addPackageTask: addPackageTask,
    packageItem: packageItem,
    parameterAllDataPopup: parameterAllDataPopup
  },
  data: function data() {
    return {
      pagingReqFn: "operationList",
      delIds: [],
      timer: null,
      timing: [{
        label: '否',
        value: 2
      }, {
        label: '是',
        value: 1
      }],
      statusList: [{
        label: '未开始',
        value: 0
      }, {
        label: '打包中',
        value: 1
      }, {
        label: '打包成功',
        value: 2
      }, {
        label: '打包失败',
        value: 3
      }, {
        label: '定时打包未开始',
        value: 4
      }]
    };
  },
  mounted: function mounted() {
    this.startIntervalRequest();
  },
  activated: function activated() {
    this.getcommonDataNew(['operationList', 'gameGroupList', 'originPkgList', 'originPkgTypeList']);
    this.getList();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearRequestInterval();
  },
  methods: {
    startIntervalRequest: function startIntervalRequest() {
      var _this = this;

      this.timer = setInterval(function () {
        _this.getList(_this.paramsData.page, true);
      }, 5000);
    },
    // 清除定时器
    clearRequestInterval: function clearRequestInterval() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    getList: function getList() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var isShowLoading = arguments.length > 1 ? arguments[1] : undefined;
      this.paramsData.page = page;
      this.paramsData.appid ? this.paramsData.isSearch = true : this.paramsData.isSearch = false;

      if (!this.pagingReqFn) {
        console.error('请传入请求函数');
        return false;
      }

      if (!isShowLoading) {
        this.reqLoading = true;
      }

      var appid = '';

      if (Array.isArray(this.paramsData.appid)) {
        appid = this.paramsData.appid.join(",");
      } else {
        appid = this.paramsData.appid;
      }

      api[this.pagingReqFn](_objectSpread(_objectSpread({}, this.paramsData), {}, {
        appid: appid
      })).then(function (res) {
        if (res.status == 200) {
          if (page > 1 && !res.data.data.length) {
            _this2.getList(page - 1);
          } else {
            var data = res.data;
            _this2.total = data.total || 0;
            _this2.tableData = _this2.pagingReqValue ? data[_this2.pagingReqValue] || [] : data || [];
          }
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    selectable: function selectable(row) {
      if (row.status == 0 || row.status == 2 || row.status == 4) {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    downLoad: function downLoad(url) {
      window.open(url);
    },
    del: function del(dateList) {
      var _this3 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'operationDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this3.getList(_this3.paramsData.page);
      });
    },
    getcommonData: function getcommonData() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqList, _iterator, _step, i, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqList = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
                _iterator = _createForOfIteratorHelper(reqList);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 12;
                  break;
                }

                i = _step.value;
                _context.next = 8;
                return _this4.$api[i]({
                  pageSize: 1000
                });

              case 8:
                res = _context.sent;
                _this4[i] = res.data.data;

              case 10:
                _context.next = 4;
                break;

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);

                _iterator.e(_context.t0);

              case 17:
                _context.prev = 17;

                _iterator.f();

                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 14, 17, 20]]);
      }))();
    },
    pkgStart: function pkgStart(id) {
      var _this5 = this;

      this.$api.operationStart({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          _this5.$message({
            message: '操作成功',
            type: 'success'
          });

          _this5.getList(_this5.paramsData.page);
        }
      });
    },
    watchParams: function watchParams(data) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var copyData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                copyData = JSON.parse(data.params);
                _context2.next = 3;
                return delete copyData.adv_config;

              case 3:
                _context2.next = 5;
                return delete copyData.key_store;

              case 5:
                _context2.next = 7;
                return delete copyData.platform_params;

              case 7:
                _context2.next = 9;
                return delete copyData.sdk_download_url;

              case 9:
                _this6.$refs.parameterAllDataPopup.init(JSON.stringify(copyData));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};